module.exports = __webpack_public_path__ + "img/userPhoto.999f988b.jpg";